import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/services/jwt.service";
import ErrorService from "@/services/errors.service";
import CrawlerService from "./crawler.service";

const ApiAxios = axios.create()

// Armazena as requisições pendentes para possível cancelamento
let pendingRequests = [];

const ApiService = {
  init() {
    this.setupHeaders();

    // Interceptor para adicionar requisições à lista de pendentes
    ApiAxios.interceptors.request.use(config => {
      // Cria um CancelToken para esta requisição
      const source = axios.CancelToken.source();
      config.cancelToken = source.token;

      // Adiciona à lista de requisições pendentes
      pendingRequests.push({
        source,
        url: config.url
      });

      return config;
    }, error => {
      return Promise.reject(error);
    });

    ApiAxios.interceptors.response.use(function(response) {
      // Remove da lista de pendentes quando completa
      pendingRequests = pendingRequests.filter(req => req.url !== response.config.url);
      return response;
    }, this.handleError);

    Vue.use(VueAxios, ApiAxios);
  },

  cancelPendingRequests() {
    // Cancela todas as requisições pendentes
    pendingRequests.forEach(req => {
      req.source.cancel('Requisição cancelada devido à troca de loja');
    });
    // Limpa a lista
    pendingRequests = [];
  },

  getBaseUrl() {
    return window.location.host == "localhost:8080"
      ? "http://localhost:8000"
      : "/api";
  },

  setupHeaders() {
    ApiAxios.defaults.baseURL = this.getBaseUrl();
    ApiAxios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${JwtService.getToken()}`;
    ApiAxios.defaults.headers.common[
      "BranchId"
    ] = `${JwtService.getBranchId()}`;

    CrawlerService.setupHeaders();
  },

  handleError(_error) {
    // Remove da lista de pendentes em caso de erro
    if (_error.config) {
      pendingRequests = pendingRequests.filter(req => req.url !== _error.config.url);
    }

    // Ignora erros de requisições canceladas
    if (axios.isCancel(_error)) {
      console.log('Requisição cancelada:', _error.message);
      return Promise.reject({ canceled: true, message: _error.message });
    }

    var error = _error;
    if (_error.response !== undefined) {
      error = _error.response;
    }

    ErrorService.http(error);
    return Promise.reject(error);
  },

  query(_resource, _data) {
    return Vue.axios.get(_resource, { params: _data });
  },

  download(_resource, _slug = "") {
    if (_slug == "") {
      return Vue.axios.get(`${_resource}`, {responseType: 'arraybuffer'});
    } else {
      return Vue.axios.get(`${_resource}/${_slug}`, {responseType: 'arraybuffer'});
    }
  },

  postDownload(_resource, _params) {
    return Vue.axios.post(`${_resource}`, _params, {responseType: 'arraybuffer'});
  },

  get(_resource, _slug = "") {
    if (_slug == "") {
      return Vue.axios.get(`${_resource}`);
    } else {
      return Vue.axios.get(`${_resource}/${_slug}`);
    }
  },

  getAxiosInstance() {
    return ApiAxios;
  },

  post(_resource, _params) {
    return Vue.axios.post(`${_resource}`, _params);
  },

  put(_resource, _id, _params) {
    return Vue.axios.put(`${_resource}/${_id}`, _params);
  },

  patch(_resource, _id, _params) {
    return Vue.axios.patch(`${_resource}/${_id}`, _params);
  },

  delete(_resource, _id) {
    return Vue.axios.delete(`${_resource}/${_id}`);
  }
};

Vue.mixin({
  methods: {
    setupHeaders() {
      ApiService.setupHeaders();
    }
  }
});

export default ApiService;